export default "__VITE_ASSET__zyKjS$Ce__"